const translateContactsTypes = {
  PERSONAL: 'Pessoal',
  BUSINESS: 'Corporativo'
}

export default translateContactsTypes
